export const res = {
  readMore: {
    // TODO: verify translations
    is: 'Nánar',
    en: 'Read more',
    pl: 'Więcej',
  },
} as const;
